<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    // 解决vue页面刷新后原先获取的vuex中state消失的问题
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里 pagehide在页面刷新或关闭之前执行
    window.addEventListener("pagehide", () => {
      this.$store.commit("setIsLoad", true);
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
};
</script>
<style>
@font-face {
  font-family: "DINAlternate-Bold";
  src: url("./assets/font/DIN-Bold.otf");
}
@font-face {
  font-family: "DIN-Bold";
  src: url("https://static0.xesimg.com/platform-fe/trade/common/files/fonts/DIN-Bold.otf")
    format("opentype");
}
@font-face {
  font-family: "DIN-Bold-700";
  src: url("https://static0.xesimg.com/trade/uploads/fonts/D-DIN-PRO-700-Bold.otf")
    format("opentype");
}
@font-face {
  font-family: "MFYuanHeiNoncommercial";
  src: url("./assets/font/ZaoZiGongFangYuanHeiTi-2.ttf");
  /* src: url("./assets/font/ZaoZiGongFangYuanHeiTi-raw.ttf"); */
}
@font-face {
  font-family: "MFYuanHeiNoncommercial-lv";
  src: url("./assets/font/ZaoZiGongFangYuanHeiTi-3.ttf");
}
@font-face {
  font-family: "MFYuanHeiNoncommercial-lb";
  src: url("./assets/font/MFYuanHeiNoncommercial12.ttf");
}
/* 该字体包只有一个字：荐 */
@font-face {
  font-family: "MFYuanHeiNoncommercial-4";
  src: url("./assets/font/ZaoZiGongFangYuanHeiTi-4.ttf");
}
@font-face {
  font-family: "FZZhengHeiS-EB-GB";
  src: url("./assets/font/FZZDHJW.TTF") format("truetype");
}
</style>
